/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

export function IbanCard({ iban = "", title = "Avrupa Hesabı" }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        background: "linear-gradient(90deg, #FF823C 0%, #FFA742 100%)",
        borderRadius: 2,
        p: 1.5,
        color: "white",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: 0.5,
        }}
      >
        <InfoIcon
          sx={{
            fontSize: 20,
            color: "rgba(0, 0, 0, 0.7)",
          }}
        />
        <Typography
          sx={{
            fontSize: "1rem",
            fontWeight: "bold",
            color: "white",
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: isMobile ? "flex-start" : "center",
          flexDirection: isMobile ? "column" : "row",
          gap: 0.5,
          pl: 0.3,
        }}
      >
        <Typography
          sx={{
            fontSize: "1rem",
            fontWeight: 400,
            opacity: 0.9,
          }}
        >
          IBAN:
        </Typography>
        <Typography
          sx={{
            letterSpacing: "0.5px",
            fontSize: "1rem",
            fontWeight: 500,
            ml: 0.5,
          }}
        >
          {iban}
        </Typography>
      </Box>
    </Box>
  );
}
